import React from 'react';

import {buildUrl} from '../routes';
import {Seo} from './seo';
import {buildKeywords} from './keywords';
import {pageJsonLd, sectionCrumbs} from './json-ld';
import {SECTIONS, SectionKey} from './sections';
import {ogImageUrl} from './site';

import css from './section-seo.module.css';

export const SectionSeo: React.FC<{section: SectionKey; headingClassName?: string}> = ({section, headingClassName}) => {
	const {title, description, route, heading} = SECTIONS[section];
	const path = buildUrl(route);

	return (
		<>
			<Seo
				title={title}
				description={description}
				canonicalPath={path}
				keywords={buildKeywords(section)}
				ogImage={ogImageUrl('section', section)}
				jsonLd={pageJsonLd({
					path,
					title,
					description,
					crumbs: sectionCrumbs(section),
					pageType: section === 'index' || section === 'trans14to24' ? 'WebPage' : 'CollectionPage',
				})}
			/>
			<h1 className={headingClassName ?? css.heading}>{heading}</h1>
		</>
	);
};
